<template>
  <!-- shared conversation viewer used by both the Feedback Review detail
       modal and the Assistant Insights conversation detail view. -->
  <div v-if="messages && messages.length > 0" class="fa-conv-viewer">
    <div v-for="(msg, mIdx) in messages" :key="mIdx" class="fa-conv-turn">
      <!-- user bubble: right-aligned, blue -->
      <div v-if="msg.role === 'user'" style="text-align: right;">
        <div class="fa-conv-bubble fa-conv-bubble--user">{{ msg.content }}</div>
      </div>
      <!-- assistant bubble: left-aligned, grey, markdown rendered -->
      <div v-else style="text-align: left;">
        <div class="fa-conv-bubble fa-conv-bubble--assistant markdown-content" v-html="renderMarkdown(msg.content)"></div>
        <div class="fa-conv-meta">
          <span v-if="msg.model">{{ msg.model }}</span>
          <span v-if="msg.tokens">{{ msg.tokens }} tokens</span>
          <span v-if="msg.cost">{{ formatCost(msg.cost) }}</span>
          <span v-if="msg.tool_calls && msg.tool_calls.length > 0" class="fa-conv-tools">
            <i class="fa fa-wrench" style="margin-right: 2px;"></i>
            <span v-for="(tc, tcIdx) in msg.tool_calls" :key="tcIdx" class="fa-conv-tool-pill">
              {{ tc.name }}<span v-if="tc.duration_ms" style="color: #888;"> {{ tc.duration_ms }}ms</span><span v-if="tcIdx < msg.tool_calls.length - 1">, </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="fa-conv-empty">
    <i class="fa fa-comments-o" style="margin-right: 6px;"></i>No turns in this session.
  </div>
</template>

<script>
import { renderMarkdownToHtml } from '../../utils/markdown_renderer'

export default {
  name: 'FaConversationViewer',
  props: {
    messages: { type: Array, default: () => [] },
  },
  methods: {
    renderMarkdown (content) {
      if (!content) return ''
      return renderMarkdownToHtml(content)
    },
    formatCost (cost) {
      // preserve the prior formatting used in the feedback modal
      if (typeof cost === 'number') return '$' + cost.toFixed(4)
      return cost
    },
  },
}
</script>

<style scoped>
.fa-conv-viewer {
  background: #f9f9f9;
  padding: 16px;
  border-radius: 8px;
  max-height: 500px;
  overflow-y: auto;
}
.fa-conv-turn { margin-bottom: 15px; }
.fa-conv-bubble {
  display: inline-block;
  padding: 10px 15px;
  border-radius: 18px;
  max-width: 70%;
  word-wrap: break-word;
}
.fa-conv-bubble--user {
  background-color: #007ac7;
  color: white;
}
.fa-conv-bubble--assistant {
  background-color: #e9ecef;
  color: #333;
}
.fa-conv-meta {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.fa-conv-tools {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.fa-conv-tool-pill {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 0 6px;
  margin-right: 3px;
  color: #555;
}
.fa-conv-empty {
  color: #888;
  font-size: 13px;
  padding: 20px;
  text-align: center;
  background: #f9f9f9;
  border-radius: 8px;
}
</style>
